import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import { Edit2, Trash2 } from 'react-feather';

// Imports custom
import {
    TooltipInformation,
    CustomTableData,
    LinearLoading,
    CustomDropDown
} from 'common'

export const ExpensesTable = ({ useFetchInit, readOnlyMode }) => {

    const {
        //------------- Generales
        //------------- globalStates
        // globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    // const { stepApplilication } = globalStates

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    
    // ------------------------------------------------ FetchData
    const { fetchAllExpenses } = FetchData
    const { dataExpenses, loadingFetchAllExpenses } = fetchAllExpenses
    
    // ------------------------------------------------ Actions
    const {
        handleClickFetchSpecificExpense,
        handleClickDeleteExpense
    } = Actions

    const columnConfig = [
        {
            //FIELD PARA TOOLTIP
            headerName: 'Info',
            maxWidth: 80,
            cellStyle: () => ({
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }),
            cellRenderer: (params) => {
                //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
                const { usuario_creo, fecha_creo, usuario_modifico, fecha_modifico } =
                    params.data
                return (
                    <TooltipInformation
                        usuario_creo={usuario_creo}
                        fecha_creo={fecha_creo}
                        usuario_modifico={usuario_modifico}
                        fecha_modifico={fecha_modifico}
                    />
                )
            }
        },
        { field: "expense_description", headerName: "DESCRIPCION", minWidth: 150, filter: true },
        { 
            field: "amount", headerName: "COSTO", minWidth: 250, filter: true,
            cellRenderer: (params) => 'Q ' + parseFloat(params.value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        { field: "observation", headerName: "OBSERVACION", minWidth: 200, filter: true },
        {
            headerName: 'Opciones',
            minWidth: 350,
            cellRenderer: (params) => {
                const { idlawyerexpense, estado } = params.data
                return (
                    <CustomDropDown color={(estado===1)?'inherit':'error'}>
                        <MenuItem
                            onClick={() => handleClickFetchSpecificExpense(idlawyerexpense)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Edit2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Informacion" />
                        </MenuItem>
                        <MenuItem
                            onClick={() => handleClickDeleteExpense(idlawyerexpense)}
                            disabled={readOnlyMode}
                        >
                            <ListItemIcon> <Trash2 color="black"/> </ListItemIcon>
                            <ListItemText primary="Eliminar" />
                        </MenuItem>
                    </CustomDropDown>
                )
            }
        }
    ]

    return (
        <div className='content'>
            {(loadingFetchAllExpenses)&&(<LinearLoading />)}
            <CustomTableData 
                rowConfig={dataExpenses}
                columnConfig={columnConfig}
            />
        </div>
    )
}
